import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService extends AbstractService {
  xplay(type: string): Observable<void> {
    return this.post<void>('/xplay/start', { type });
  }
}